module.exports = __webpack_public_path__ + "static/media/icon-piece-loa-03.35576714.png";